
    <fieldmagic-primary-button
      purpose="icon"
      icon="tasks"
      (click)="showDialog()"
      tooltip="Add response"
      [isInProgress]="previewing$ | async"
    >
    </fieldmagic-primary-button>
  